import SubText from "components/shared/SubText";
import { decodeHtmlEntities } from "constant/htmlEntities";
import React from "react";
import { FaYoutube } from "react-icons/fa";
import {
  FaInstagram,
  FaSquareFacebook,
  FaSquareTwitter,
  FaTiktok,
} from "react-icons/fa6";

function AboutPage({ creatorData }: any) {
  // Date conversion
  const dateString = `${creatorData?.released_at}`;

  const joinDate = new Date(dateString);

  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "short",
    day: "numeric",
  };
  const formattedDate = joinDate.toLocaleDateString("en-US", options);

  const socialBtn =
    "flex h-11 w-11 items-center justify-center rounded-full border border-white/10 bg-white/5 text-[18px] text-white transition-all duration-300 hover:-translate-y-0.5 hover:border-[var(--red)] hover:bg-[var(--red)] hover:text-white hover:shadow-lg hover:shadow-[var(--red)]/30";

  return (
    <div className="mt-10 ml-6 max-sm:ml-0">
      {/* top section */}
      <div className="flex">
        <div className="w-[70%] max-sm:w-full">
          {/* Description */}
          {creatorData?.general_info?.description && (
            <div>
              <SubText text="Description" />
              <p
                dangerouslySetInnerHTML={{
                  __html:
                    decodeHtmlEntities(creatorData?.general_info?.description).replace(
                      /\n/g,
                      "<br/>",
                    ),
                }}
                className="mt-5 w-[80%] text-[15px] font-normal leading-relaxed text-white/80 max-sm:w-[95%]"
              />
            </div>
          )}

          {/* Details */}
          {creatorData?.general_info?.country_name && (
            <div className="mt-12">
              <SubText text="Details" />

              <div className="mt-5 rounded-2xl border border-white/10 bg-white/[0.03] p-4 max-sm:w-full sm:w-[60%]">
                <div className="flex items-center text-[14px]">
                  <span className="w-28 shrink-0 text-white/50">Location</span>
                  <span className="font-medium text-white">
                    {creatorData?.general_info?.country_name}
                  </span>
                </div>
              </div>
            </div>
          )}

          {/* Links */}
          {(creatorData?.general_info?.facebook_url ||
            creatorData?.general_info?.twitter_url ||
            creatorData?.general_info?.instagram_url ||
            creatorData?.general_info?.tiktok_url ||
            creatorData?.general_info?.youtube_url) && (
            <div className="mb-20 mt-12">
              <SubText text="Links" />
              <div className="mt-5 flex flex-wrap gap-3">
                {creatorData?.general_info?.facebook_url && (
                  <a
                    href={creatorData?.general_info?.facebook_url}
                    rel="noreferrer nofollow"
                    target="_blank"
                    className={socialBtn}
                    aria-label="Facebook"
                  >
                    <FaSquareFacebook />
                  </a>
                )}
                {creatorData?.general_info?.instagram_url && (
                  <a
                    href={creatorData?.general_info?.instagram_url}
                    rel="noreferrer nofollow"
                    target="_blank"
                    className={socialBtn}
                    aria-label="Instagram"
                  >
                    <FaInstagram />
                  </a>
                )}
                {creatorData?.general_info?.twitter_url && (
                  <a
                    href={creatorData?.general_info?.twitter_url}
                    rel="noreferrer nofollow"
                    target="_blank"
                    className={socialBtn}
                    aria-label="Twitter"
                  >
                    <FaSquareTwitter />
                  </a>
                )}
                {creatorData?.general_info?.tiktok_url && (
                  <a
                    href={creatorData?.general_info?.tiktok_url}
                    rel="noreferrer nofollow"
                    target="_blank"
                    className={socialBtn}
                    aria-label="TikTok"
                  >
                    <FaTiktok />
                  </a>
                )}
                {creatorData?.general_info?.youtube_url && (
                  <a
                    href={creatorData?.general_info?.youtube_url}
                    rel="noreferrer nofollow"
                    target="_blank"
                    className={socialBtn}
                    aria-label="YouTube"
                  >
                    <FaYoutube />
                  </a>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default AboutPage;